import { render, staticRenderFns } from "./CustomModalLayout.vue?vue&type=template&id=5a3dd781&scoped=true"
import script from "./CustomModalLayout.vue?vue&type=script&lang=js"
export * from "./CustomModalLayout.vue?vue&type=script&lang=js"
import style0 from "./CustomModalLayout.vue?vue&type=style&index=0&id=5a3dd781&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3dd781",
  null
  
)

export default component.exports